import { SelectField } from 'components/fields';
import { useListQuery } from 'store/api/clover-device';

import { DeviceSelectProps } from './types';

export const DeviceSelect = ({ eventIds }: DeviceSelectProps) => {
  const { data, isLoading } = useListQuery(
    eventIds
      ? {
          eventIds: JSON.stringify(eventIds),
        }
      : undefined
  );

  const deviceOptions = data?.map((device) => ({
    value: device.id,
    label: device?.name || device?.deviceId,
  }));

  return (
    <SelectField
      onlyValue
      name="deviceId"
      label="Device ID"
      isLoading={isLoading}
      options={deviceOptions}
      placeholder="Select device"
    />
  );
};
